import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import './kyc.css';
import moment from "moment";
import { v4 as uuidv4 } from 'uuid';
import { Link } from "react-router-dom";
import { store } from "../../redux/store";
import { setPersonalInfo, setRegisterRetailerResponse } from "../../redux/retailer-kyc-details/retailer-kyc-details.action";
import HeaderCommon from './../HeaderComponent/HeadeCommon';
import Menu from "../MenuComponent/Menu";
import tokenErrorHandler from "../tokenErrorHandler";
const httpClient = axios.create();
class VerifyOtp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMsg: '',
            progress: ''
        }
    }

    componentDidMount() { }
    componentWillUnmount() { }

    renewSession = (event) => {
        event.preventDefault();

        this.setState({
            errorMsg: ''
        })
        var renewSessionUrl = '/api/v1/retailer/onboard/session/renew';
        var header = {
            msgType: "CREATE_ORDER",
            service: "KYC",
            src: "register-retailer",
            dst: "register-retailer",
            channel: "API",
            requesterId: "client.whitelabel@finxpay",
            requestId: uuidv4(),
            traceId: uuidv4(),
        }
        var request = {
            header: header,
            deviceInfo: this.props.deviceInfo,
            mobile: this.state.mobile
        }
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }
        console.log('renew retailer req:' + JSON.stringify(request));

        httpClient.post(renewSessionUrl, request,
            { headers }
        ).then((response) => {
            console.log('register retailer renew response' + JSON.stringify(response.data));

            store.dispatch(setRegisterRetailerResponse(response.data))

            if (response.data.response.success == true) {

                // var dobArr=this.state.dob.split("-")
                // var dob=dobArr[2]+'/'+dobArr[1]+'/'+dobArr[0]
                // alert(dob)
                var personalInfo = {
                    gender: this.state.gender.toUpperCase(),
                    fname: this.state.retailerFirstName,
                    lname: this.state.retailerLastName,
                    email: this.state.email,
                    mobile: this.state.mobile,
                    dob: this.state.dob,
                    address: null,
                    selfie: ''

                }
                store.dispatch(setPersonalInfo(personalInfo))

                this.setState({
                    progress: 'completed'
                })

            } else {
                this.setState({
                    errorMsg: 'Something went wrong',
                    progress: 'completed'
                })

            }

        }).catch(error => {
            this.setState({
                errorMsg: 'Something went wrong',
                progress: 'completed'
            })
            if(error.message.includes("401")){
                tokenErrorHandler.tokenErrorHandle(error.message,this.props.callBackUrl)
            }else{
                
            }
    

        });
    }


    authenticateSessionValidation = () => {

        //will add code here
        return true;
    }
    authenticateSession = (event) => {
        event.preventDefault();
        this.setState({
            errorMsg: '',
            progress: 'loading'
        })
        if (this.authenticateSessionValidation() == true) {
            var authenticateSessionUrl = '/api/v1/retailer/onboard/session/authenticate';
            var header = {
                msgType: "CREATE_ORDER",
                service: "KYC",
                src: "register-retailer",
                dst: "register-retailer",
                channel: "API",
                requesterId: this.props.clientRequesterId,
                requestId: uuidv4(),
                traceId: uuidv4(),
            }

            var otpDetails = {
                type: this.props.registerRetailerResponse.otpDetails.type,
                refNo: this.props.registerRetailerResponse.otpDetails.refNo,
                otp: this.state.otp,
                mobile: this.props.registerRetailerResponse.otpDetails.mobile
            }
            var request = {
                header: header,
                sessionId: this.props.registerRetailerResponse.sessionId,
                otpDetails: otpDetails
            }
            const headers = {
                'Authorization': 'Bearer ' + this.props.token,
                'client-id': this.props.agentInfo.id,
                'role': this.props.clientRole
            }
            httpClient.post(authenticateSessionUrl, request,
                { headers }
            ).then((response) => {
                console.log('authenticateSession response' + JSON.stringify(response.data));

                if (response.data.response.success == true) {

                    this.setState({
                        progress: 'completed'
                    })

                    this.goToUploadDoc();
                } else {
                    this.setState({
                        progress: 'completed',
                        errorMsg: response.data.response.displayMsg
                    })
                }

            }).catch(error => {
                this.setState({
                    progress: 'completed',
                    errorMsg: 'Something went wrong'
                })
                if(error.message.includes("401")){
                    tokenErrorHandler.tokenErrorHandle(error.message,this.props.callBackUrl)
                }else{
                    
                }


            });
        }
    }

    goToUploadDoc = () => {
        var goToUploadDocBtn = document.getElementById('goToUploadDocBtn');
        goToUploadDocBtn.click();

    }

    enterOtp = (event) => {
        event.preventDefault();
        this.setState({
            otp: event.target.value
        })
    }

    backToRegister = () => {
        var backToRegisterBtn = document.getElementById('backToRegisterBtn');
        backToRegisterBtn.click();
    }





    render() {


        return (
            <div>
                <HeaderCommon />
                <Menu />
                <div class="mid-contant">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="main-heading">
                                    <h2>Verify Mobile number</h2>
                                </div>
                                <Link to='/upload-retailer'>
                                    <button id='goToUploadDocBtn' hidden={true}></button>
                                </Link>
                            </div>

                            <div class="col-12">
                                <div class="registerbox">
                                    <div class="row mb-3">
                                        <div class="col-12 col-lg-7">
                                            {/* <form action="document.html"> */}
                                            <div class="row">

                                                <div class="col-12">
                                                    <div class="otptxt">Enter the 6 digit OTP sent to your mobile number: +91-{this.props.registerRetailerResponse.otpDetails.mobile}</div>
                                                </div>

                                                <div class="col-12 col-md-8">
                                                    <div class="form-floating">
                                                        <input type="number" class="form-control" id="otp" placeholder="Enter OTP"
                                                            onChange={this.enterOtp}
                                                            onInput={(e) => e.target.value = e.target.value.slice(0, 6)}
                                                            required />
                                                        <label for="otp">Enter OTP</label>
                                                    </div>
                                                    {this.state.errorMsg != '' &&
                                                        <div class='valid-error'>
                                                            {this.state.errorMsg}
                                                        </div>}
                                                </div>

                                                <div class="col-6 col-md-5">
                                                    <button type="submit" class="btn btn-primary" id=""
                                                        onClick={this.authenticateSession}
                                                        disabled={this.state.progress == 'laoding' && true}
                                                    >Verify Now</button>

                                                </div>



                                                <div class="col-6 col-md-7">
                                                    <button type="button" class="btn btn-trp" id=""
                                                        onClick={this.sessionCreate}>Resend OTP</button>
                                                </div>

                                                <div class="col-12 mt-4 d-none">
                                                    <div class="spinner-border spinner-border-sm text-primary" role="status">
                                                        <span class="visually-hidden">Loading...</span>
                                                    </div>
                                                    <div class="timmer">45</div>
                                                </div>
                                            </div>
                                            {/* </form> */}
                                        </div>

                                        <div class="col-12 col-lg-5 d-none d-lg-block border-start">
                                            <div class="topbtn">
                                                <a onClick={this.backToRegister}>Back</a>
                                            </div>
                                            <Link to='/register-retailer'>
                                                <button id='backToRegisterBtn' hidden={true}></button>
                                            </Link>
                                            <div class="rightbanner"><img src="images/otp-img.png" alt="Oxigen" class="img-fluid" /></div>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage, otpErrorMessage },
        miscReduce: { phone, token, clientRole, agentInfo, clientRequesterId,callBackUrl },
        retailerKycReduce: { registerRetailerResponse }
    }
) => ({
    errorMessage, loginErrorMessage, otpErrorMessage, phone, token, clientRole, agentInfo,
     clientRequesterId,callBackUrl, registerRetailerResponse
});

export default connect(mapStateToProps, null)(VerifyOtp);
